import { HttpErrorResponse } from '@angular/common/http';

export class NotFoundError extends Error {
    httpStatus = 404;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
